<template>
    <div class="chongzhijilu">
        <!-- 温馨提示 -->
        <div class="tip-card">
            <div class="tip-icon">💡</div>
            <div class="tip-text">温馨提示：若充值成功，缩币未及时到账，请及时联系客服</div>
        </div>

        <!-- 统计卡片 -->
        <div class="stats-card">
            <div class="card-header">
                <div class="header-title">缩币充值</div>
            </div>
            <div class="card-body">
                <div class="stat-item">
                    <div class="stat-value">{{ statistics.money }}</div>
                    <div class="stat-label">当前充值（元）</div>
                </div>
                <div class="stat-item">
                    <div class="stat-value">{{ statistics.virtualCoin }}</div>
                    <div class="stat-label">收益缩币（个）</div>
                </div>
                <div class="stat-item">
                    <div class="stat-value">{{ statistics.consumptionCoin }}</div>
                    <div class="stat-label">消费缩币（个）</div>
                </div>
                <div class="stat-item highlight">
                    <div class="stat-value">{{ statistics.residueCoin }}</div>
                    <div class="stat-label">缩币余额（个）</div>
                </div>
                <div class="stat-item">
                    <div class="stat-value">{{ statistics.unpaidOrder }}</div>
                    <div class="stat-label">未付款订单（个）</div>
                </div>
            </div>
        </div>

        <!-- 充值记录表格 -->
        <div class="table-card">
            <div class="card-header">
                <div class="header-title">充值记录</div>
            </div>
            <el-table v-loading="tableLoading" :data="tableData" border style="width: 100%"
                :header-cell-style="{ color: '#ffffff', backgroundColor: '#409eff', fontWeight: '600' }">
                <el-table-column prop="orderNo" label="充值单号" show-overflow-tooltip />
                <el-table-column prop="payType" label="充值方式">
                    <template slot-scope="scope">
                        <span :style="{ color: getPayTypeColor(scope.row.payType), fontWeight: '500' }">
                            {{ scope.row.payType | handlePretype(preType) }}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column prop="virtualcoin" label="缩币" />
                <el-table-column prop="createTime" label="充值时间" show-overflow-tooltip />
                <el-table-column prop="updateTime" label="缩币到账时间" show-overflow-tooltip />
                <el-table-column prop="status" label="充值状态">
                    <template slot-scope="scope">
                        <span :style="{ color: getStatusColor(scope.row.status.displayName), fontWeight: '500' }">
                            {{ scope.row.status.displayName }}
                        </span>
                    </template>
                </el-table-column>
            </el-table>

            <el-pagination v-if="listPagin.total > 9" style="padding: 20px; text-align: right;" background
                layout="prev, pager, next" @current-change="changePage" :page-size="listPagin.limit"
                :total="listPagin.total">
            </el-pagination>
        </div>
    </div>
</template>

<script>
import { count, record, } from '@/api/chongzhi';
import { queryDictionary } from "@/api/common"
export default {
    data() {
        return {
            preType: [],

            tableData: [],		//充值记录
            statistics: {},		//充值统计

            tableLoading: false,

            listPagin: {
                page: 1,
                limit: 10,
                total: 0
            },

        };
    },
    filters: {
        handlePretype(val, preType) {
            return preType.filter(item => item.dictValue == val)[0].dictLabel
        }
    },
    mounted() {
        // 充值统计
        count().then(res => this.statistics = res.data)

        queryDictionary('pre_pay_type').then(res => {
            this.preType = JSON.parse(JSON.stringify(res.data, ['dictLabel', 'dictValue']))
            this.getList()
        })

    },
    methods: {
        getStatusColor(status) {
            const statusMap = {
                '支付成功': '#10b981',
                '支付失败': '#ef4444',
                '待支付': '#f59e0b',
                '成功': '#10b981',
                '失败': '#ef4444',
                '处理中': '#f59e0b'
            }
            return statusMap[status] || '#333'
        },

        getPayTypeColor(payType) {
            const payTypeMap = {
                'wxpay': '#07c160',  // 微信支付 - 绿色
                'alipay': '#1677ff'  // 支付宝 - 蓝色
            }
            return payTypeMap[payType] || '#333'
        },

        getList() {
            // 充值记录
            record({
                pageNum: this.listPagin.page,
                pageSize: this.listPagin.limit,
            }).then(res => {
                console.log(res);
                this.tableLoading = false
                let { total, rows } = res.data
                this.tableData = rows
                this.listPagin.total = total
            })
        },

        // 分页状态变化
        changePage(e) {
            this.tableLoading = true
            this.listPagin.page = e
            this.getList();
        },
    }
};
</script>

<style lang="scss" scoped>
.chongzhijilu {

    // 温馨提示卡片
    .tip-card {
        display: flex;
        align-items: center;
        background: linear-gradient(135deg, #fff5f0 0%, #fffbe6 100%);
        border: 1px solid #ffe0b2;
        border-radius: 12px;
        padding: 16px 20px;
        margin-bottom: 20px;
        gap: 12px;

        .tip-icon {
            font-size: 20px;
            flex-shrink: 0;
        }

        .tip-text {
            font-size: 14px;
            color: #8b4513;
            line-height: 1.6;
        }
    }

    // 统计卡片
    .stats-card {
        background: #fff;
        border-radius: 16px;
        box-shadow: 0 4px 16px rgba(0, 0, 0, 0.06);
        overflow: hidden;
        margin-bottom: 20px;
        border: 1px solid #e8eef3;

        .card-header {
            background: linear-gradient(135deg, #409eff 0%, #2d8cf0 100%);
            padding: 18px 24px;

            .header-title {
                font-size: 16px;
                font-weight: 600;
                color: #fff;
                letter-spacing: 0.5px;
            }
        }

        .card-body {
            padding: 24px;
            display: flex;
            flex-wrap: wrap;
            gap: 20px;

            .stat-item {
                flex: 1;
                min-width: 140px;
                text-align: center;
                padding: 16px;
                background: #f8fafc;
                border-radius: 12px;
                transition: all 0.3s ease;

                &:hover {
                    transform: translateY(-2px);
                    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
                }

                &.highlight {
                    background: linear-gradient(135deg, #fff5f5 0%, #ffeaea 100%);
                    border: 1px solid #ffd6d6;

                    .stat-value {
                        color: #E92728;
                    }
                }

                .stat-value {
                    font-size: 24px;
                    font-weight: 700;
                    color: #334155;
                    margin-bottom: 6px;
                }

                .stat-label {
                    font-size: 13px;
                    color: #64748b;
                }
            }
        }
    }

    // 表格卡片
    .table-card {
        background: #fff;
        border-radius: 16px;
        box-shadow: 0 4px 16px rgba(0, 0, 0, 0.06);
        overflow: visible;
        border: 1px solid #e8eef3;

        .card-header {
            background: linear-gradient(135deg, #409eff 0%, #2d8cf0 100%);
            padding: 18px 24px;

            .header-title {
                font-size: 16px;
                font-weight: 600;
                color: #fff;
                letter-spacing: 0.5px;
            }
        }

        :deep(.el-table) {
            --el-table-row-hover-bg-color: #f8fafc;
        }

        :deep(.el-table__row) {
            transition: background-color 0.2s ease;
        }
    }

    // 状态样式
    :deep(.status-success) {
        color: #10b981 !important;
        font-weight: 500;
    }

    :deep(.status-fail) {
        color: #ef4444 !important;
        font-weight: 500;
    }

    :deep(.status-pending) {
        color: #f59e0b !important;
        font-weight: 500;
    }

    // 充值方式样式
    :deep(.pay-wechat) {
        color: #07c160 !important;
        font-weight: 500;
    }

    :deep(.pay-alipay) {
        color: #1677ff !important;
        font-weight: 500;
    }
}
</style>
